export const normalizeStatus = (status?: string | null): string => (status || '').trim().toLowerCase();

export const isProcessedStatus = (status?: string | null): boolean => normalizeStatus(status) === 'processed';
